import { Badge } from "@/components/ui/badge";

/**
 * Badge d'état d'une carte (WTS/WTB) : "Loose · <condition>" pour une carte
 * non gradée (grader=RAW), ou "<grader> <grade>" pour une carte gradée.
 * Partagé entre CardDetailView, Marketplace et Me (même rendu partout).
 */
export function StateBadge({
  grader,
  grade,
  condition,
}: {
  grader: string;
  grade?: string | number | null;
  condition?: string | null;
}) {
  if (grader === "RAW") {
    return (
      <span className="inline-flex items-center gap-1.5">
        <Badge tone="neutral" variant="soft">Loose</Badge>
        <span className="font-mono text-xs">{condition}</span>
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-1.5">
      <Badge tone="info" variant="soft">{grader}</Badge>
      <span className="font-mono text-xs">{grade ?? "—"}</span>
    </span>
  );
}
